import React, { Component } from "react";
import MTSNavScrollbar from "../Navbars/MTSNavScrollbar";
import MTSFooter from "../Footers";
import axios from "axios";
import { connect } from 'react-redux'
import { Button } from "reactstrap";
import appConfig from '../../config/config';
import Banner from "../common/banner";
import AddProductForm from "./AddProductForm"
import {
    FaCheck
} from 'react-icons/fa';

const mainStyle = {
    backgroundColor: '#f2f3f3'
};

const mainContainerStyle = {
    backgroundColor: '#ffffff',
    paddingLeft: '0px',
    paddingRight: '0px'
};

class OrderConfirm extends Component {
    constructor(props) {
        super(props);
        this.state = { showBanner: false, message:'', error:false, CanAdd : false, newProd : []};
    }
    componentDidMount()
    {
        
    };
    showBanner = (error,message)=> {
        this.setState({...this.state, showBanner:true, error, message})
    }
    closeBanner = ()=> {
        this.setState({...this.state, showBanner:false})
    }
    addPCR = (myObject) => {
        axios.post(
            appConfig.apiGateway.updateOrderUrl, //Endpoint
            JSON.stringify({
                OrderId : myObject.OrderNo,
                OrderProductId: ["PCR"],
                Action: "AddProduct",
                UserName: this.props.session.session.user.name
            })
        ).then((response) => { 
            if (response.data.body.status) {
                this.showBanner(true,response.data.body.message)
            }
            else {
                this.showBanner(false,response.data.body.message)
            }
        },
        (error) => {
            this.props.showBanner(false,"Unknown error")
        })
    }

    dlink = async (o,doctype) => {
        var bdata = (doctype == 'invoice') ? o.inv_pdf_base64 : o.pdf_base64
        var binary = atob(bdata.replace(/\s/g, ''));
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var pdf = new Uint8Array(buffer);
        for (var i = 0; i < len; i++) {
            pdf[i] = binary.charCodeAt(i);
        }
        const url = window.URL.createObjectURL(new Blob([pdf]));
        const link = document.createElement('a');
        link.href = url;
        var filename = 'file.pdf'
        if (doctype == 'invoice') {
            filename = 'INV_' + o.Address + '.pdf'
        }
        else {
            filename = 'AVM_' + o.Address + '.pdf'
        }
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
    }
Add = (val) => {
    this.setState({...this.state, CanAdd:val})
}
successBanner = (prod) => {
    this.state.newProd.push(prod);
}

render() {
        var myObject = this.props.data;
        return (
            <>
                {this.state.showBanner && (<Banner Close={this.closeBanner} 
                IsSuccess={this.state.error}
                message={this.state.message} />)}
                <div style={mainStyle}>
                    <div className="container" style={mainContainerStyle}>
                        <div className="card">
                            <div className="card-header alert alert-success">
                                <h5 className="mb-0">Order Created </h5>
                            </div>
                            <div className="card-body">
                                <p>Order {myObject.Message} has been created for property address {myObject.Address}</p>

                                {myObject.AvmStatus == "S" && 
                                    (
                                    <div className="card">
                                        <div className="card-header">
                                            <h5 className="mb-0">AVM Report<button className="btn btn-primary float-right ml-2"
                                                onClick={() => this.dlink(myObject,'avm')} type="button">Report</button>
                                                <button className="btn btn-primary float-right"
                                                onClick={() => this.dlink(myObject,'invoice')} type="button">Invoice</button>
                                            </h5>

                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table">
                                                    <tbody>
                                                        <tr>
                                                            <td>AVM Value</td>
                                                            <td>Confidence Score</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{myObject.AvmValue}</td>
                                                            <td>{myObject.AvmScore}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    )}
                                {myObject.AvmStatus == "F" && 
                                    (
                                        <div className="card">
                                            <div className="card-header">
                                            </div>
                                            <div className="card-body">
                                                <div className="table-responsive">
                                                    <table className="table">
                                                        <tbody>
                                                            <tr>
                                                                <td>Error Code</td>
                                                                <td>Error Message</td>
                                                            </tr>
                                                            <tr>
                                                                <td>{myObject.error}</td>
                                                                <td>{myObject.err_msg}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                <ul className="list-group">
                                    {myObject.Products.map((item, index) => (
                                        <li className="list-group-item"><span>{item}</span></li>
                                    ))}
                                    {this.state.newProd.map((item, index) => (
                                        <li className="list-group-item" style={{backgroundColor:'#d5f8d5'}}>
                                            <FaCheck/>
                                            <span>{item}</span></li>
                                    ))}
                                   
                                </ul>
                                <div style={{float:'right', margingTop:'8px'}}>
                                        <Button onClick={()=>this.props.complete()}
                                                color="primary">New Order</Button>
                                        <Button color="primary"
                                                 //onClick={()=> this.addPCR(myObject)} 
                                                 onClick={()=> this.setState({...this.state, CanAdd:true})} 

                                                style={{marginLeft:'5px'}}>Add PCR</Button>

                                {(this.state.CanAdd) &&  <AddProductForm  
                                    Add={this.Add} 
                                    showBanner={this.successBanner}
                                    OrderId={myObject.OrderNo}></AddProductForm> }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
const mapStateToProps = state => {
    return { session: state.session }
}
export default connect(mapStateToProps)(OrderConfirm);